import { urlBase64ToUint8Array } from 'utils/functions';

const pushServerPublicKey = process.env.REACT_APP_PUSH_SERVER_KEY;

const isPushNotificationSupported = () => {
  return 'serviceWorker' in navigator && 'PushManager' in window;
};

const askUserPermission = async () => {
  return await window.Notification?.requestPermission();
};

const registerServiceWorker = () => {
  return navigator.serviceWorker.register('/sw.js');
};

const createNotificationSubscription = async () => {
  const serviceWorker = await navigator.serviceWorker.ready;
  return await serviceWorker.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(pushServerPublicKey)
  });
};

const getUserSubscription = () => {
  //wait for service worker installation to be ready, and then
  return navigator.serviceWorker.ready
    .then(function(serviceWorker) {
      return serviceWorker.pushManager.getSubscription();
    })
    .then(function(pushSubscription) {
      return pushSubscription;
    });
};

export {
  isPushNotificationSupported,
  askUserPermission,
  registerServiceWorker,
  createNotificationSubscription,
  getUserSubscription
};
